import { useState, useEffect, useCallback } from "react";
import { getRecords } from '../services/api.service';

const useFetchList = (endpoint, payload) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [count, setCount] = useState(0);

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            const response = await getRecords(payload, endpoint);

            if (response?.code == 1) {
                response?.data?.forEach((element, index) => {
                    element.index = index + 1;
                });

                setData(response.data || []);
                setCount(response.count || 0);
            } else {
                setData([]);
                setError("No data found");
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setError("Error fetching data");
            setData([]);
        } finally {
            setLoading(false);
        }
    }, [endpoint, JSON.stringify(payload)]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return { data, count, loading, error, refetch: fetchData }; // Add refetch function
};

export default useFetchList;
